"use client";
import React from "react";
import { computeContainTransform } from "@/features/map/components/MapView/MapViewSvg/helpers/computeContainTransform";

export interface UseInitialMapTransformOptions {
  itemWrapperRef: React.RefObject<HTMLDivElement | null>;
  isSvgLoaded: boolean;
  floorContainerRef: React.RefObject<HTMLDivElement | null>;
  mapContainerRef: React.RefObject<HTMLDivElement | null>;
  mapOriginalBox?: React.MutableRefObject<DOMRect | null>;
}

export const useInitialMapTransform = (
  options: UseInitialMapTransformOptions
) => {
  const {
    itemWrapperRef: self,
    isSvgLoaded,
    floorContainerRef,
    mapContainerRef
  } = options;
  const mapOriginalBox = React.useRef<DOMRect | null>(null);

  return React.useMemo(() => {
    if (
      !isSvgLoaded ||
      !self.current ||
      !floorContainerRef.current ||
      !mapContainerRef.current
    )
      return null;
    if (!mapOriginalBox.current)
      mapOriginalBox.current =
        options.mapOriginalBox?.current ||
        self.current.getBoundingClientRect() ||
        null;

    return computeContainTransform(mapContainerRef.current, self.current, {
      gap: 0.9,
      allowUpscale: true,
      mapOriginalBox: mapOriginalBox.current
    });
  }, [self, isSvgLoaded, floorContainerRef]);
};
